import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceNewLine',
    standalone: false
})
export class ReplaceNewLinePipe implements PipeTransform {

  transform(str: string, ...args: any[]): any {
    return str?.replace(/\r\n|\r|\n/g,"<br />");
  }

}
